/* eslint-disable @typescript-eslint/no-explicit-any */
 
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(value: any, arg: any): any {
    if (!arg || arg === '' || arg.length < 3) {
      return value;
    }

    const result = [];
    for (const post of value) {
      if (post.pregunta.toLowerCase().includes(arg.toLowerCase())) {
        result.push(post);
      }
    }
    return result;
  }
}
